export default {
  'promoHeader': 'Har du husket?',
  'add':'Tilføj',
  'pickSize':'Vælg str.',
  'cartHeader':'Din kurv:',
  'addUniid':'Tilføj Navn og nummer',
  'remove':'Fjern',
  'freeDelivery':'Hey, du har fået fri levering!',
  'toCheckout':'Fortsæt til betaling',
  'totalPrice':'Total:',
  'totalDiscount':'Rabat total:',
  'deliveryPrice':'Leveringspris:',
  'size':'Størrelse:',
  'getTomoz':'Få det imorgen! Bestil inden:',
  'totalVAT':'Moms total:',
  'consent': 'Ja tak - Unisport må gerne sende mig e-mail og sms om tilsvarende fodboldprodukter fremover. Jeg kan altid framelde mig i e-mailen, hvis den ikke lever op til mine forventninger, eller ved at fjerne hakket her.'
}